import axios from 'axios'
import { bus } from '../main'
// import { UserInfo } from '../_models/userInfo'
import { EnterpriseSignUpInfo } from '../_models/enterpriseSignUpInfo'
import * as user from "../_store/user.module";
import { userUtils } from "../_utils/userUtils"


export const authService = {
    login,
    logout,
    signUp,
    validateUser,
    changeStatus
};

// const headUrl = "http://localhost:8181/RestApi/valtis/valtis"
// const siteUrl = "http://localhost:8080"

const headUrl = "https://valtis.infosys.it/RestApi/valtis/valtis"
const siteUrl = "https://valtis.infosys.it"

function login(username: string, password: string) {
    //chiamata per recupero token utente
    return axios.get(headUrl + "/checkValidation", {
        params: {
            username: username
        }
    })
        .then((resp) => {
            if (resp.data.IdStato === 5) {
                localStorage.setItem('userStatus', '5')
            }
            return axios.get(headUrl + "/Logon", {
                params: {
                    username: username,
                    password: password
                }
            })
                .then((response) => {
                    var token: string = response.data;
                    localStorage.setItem('userToken', JSON.stringify(response.data));
                    bus.$emit('startLoading')
                    // bus.$emit("checkInfo")
                    return token

                }).catch(error => {
                    bus.$emit('errorOperation', error.response.statusText)
                    throw error
                })
        }).catch(error => {
            bus.$emit('errorOperation', error.response.data)
            throw error
        })
}

function logout(): void {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('enterpriseInfo');
    localStorage.removeItem('instituteInfo');
}

function signUp(user: EnterpriseSignUpInfo) {
    // const link = generateValidationLink(user.pIva, user.emailAzienda);
    var text: string = "<html><head></head><body><h2>Benvenuto in ValtIS</h2><p>Segui questo link per verificare il tuo account e poter accedere così alle funzionalità offerte dalla piattaforma.</p><p>" + siteUrl + "/%23/validationPage?token=" + user.token + "</p></body></html> "
    //chiamata per registrazione
    return axios.post(headUrl + "/SignUp", user)
        // return axios.post("http://localhost:8181/SignUp", user)
        .then(() => {
            return axios.post(headUrl + "/Send?&recipient=" +
                user.emailAzienda +
                "&sender=noreply@valtis.infosys.it" +
                "&topic=Attivazione account ValtIS" +
                "&html=" +
                text
            ).catch(error => {
                bus.$emit('errorOperation', error.response.statusText)
                throw error
            })
        })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText)
            throw error
        })
}

// function generateValidationLink(username: string, email: string) {
//     var validationLink: string = "";
//     const key: string = 'AwO98NEkiegv';
//     var CryproJS = require("crypto-js");
//     var encryptedUsername: string = CryproJS.AES.encrypt(username, key)
//     var encode = encodeURIComponent(encryptedUsername)
//     validationLink = siteUrl + "/%23/validationPage?username=" + encode;
//     console.log(encryptedUsername)
//     return validationLink;
// }

// function base64url(source:string) {
//     var CryptoJS = require("crypto-js");
//     var encodedSource = "";
//     encodedSource = CryptoJS.enc.Base64.stringify(source);
//     encodedSource = encodedSource.replace(/=+$/, '');
//     encodedSource = encodedSource.replace(/\+/g, '-');
//     encodedSource = encodedSource.replace(/\//g, '_');
//     return encodedSource;
// }

function validateUser(token: string) {
    // const key: string = 'AwO98NEkiegv';
    // var CryptoJS = require("crypto-js");
    // var name = "davide"
    // var cryptName = CryptoJS.enc.Utf8.parse(name);
    // var encrypt = CryptoJS.AES.encrypt(name, key)
    // console.log(encrypt.toString())
    // var encode = encodeURIComponent(encrypt)
    // console.log(encode)
    // console.log(username)
    // var decode = decodeURIComponent(username)
    // console.log(decode)
    // var decryptedUsername = CryptoJS.AES.decrypt(decode.toString(), key)
    // console.log(decryptedUsername.toString(CryptoJS.enc.Utf8))
    // var decrypted = decryptedUsername.toString(CryptoJS.enc.Utf8)
    // console.log(CryptoJS.enc.Utf8.parse(decryptedUsername.toString()).toString())


    // var encoded = base64url(cryptName);
    // console.log(encoded)
    // var decode = atob(encoded)
    // console.log(decode)

    // console.log(token)
    const date = new Date();
    const payload = {
        token: token,
        date: date
    }
    return axios.post(headUrl + "/Validate", payload)
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText)
        })
}

function changeStatus(username: string) {
    var token: string | null = localStorage.getItem('userToken')
    const date = new Date();
    const payload = {
        username: username,
        date: date
    }
    return axios.post(headUrl + "/ChangeStatus", {
        params: {
            user: payload
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
        .catch(error => {
            bus.$emit('errorOperation', error.response.statusText)
        })
}